export default "__VITE_ASSET__DKjSGhZH__"